<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab" (window:resize)="onResize($event)">
		<div class="card card2 mRight" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="!hasData">
				<img [src]="placeholderimage" class="no-creative-data" />
			</div>
			<div class="c-portlet__header">
				<div class="o-stack__cell">
					<h5 class="card-title">Device Breakdown</h5>
					<span class="datatable-icon">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCsv($event)"
							target="_blank"
							*ngIf="devicedatatableconfig && devicedatatableconfig.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
					<div class="legend-area" *ngIf="legend.length > 0">
						Metric:
						<select
							id="metricLegend"
							[(ngModel)]="selectedLegendName"
							(change)="processSelectedLegendItem($event.target.value)"
						>
							<option *ngFor="let legendItem of legend" value="{{ legendItem?.value }}">
								{{ legendItem?.displayName }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div [hidden]="!hasData || !selectedGraphData" #chartcontainer class="donut-div">
				<h4 *ngIf="selectedGraphData && !isPreroll" class="device-series-titlename">
					{{ selectedGraphData.seriesName | titlecase }} by Device
				</h4>
				<h4 *ngIf="selectedGraphData && isPreroll" class="device-series-titlename">
					{{ selectedGraphData.seriesName }} by Device
				</h4>
				<app-donut
					*ngIf="selectedGraphData && selectedGraphData.seriesHasData"
					[chartData]="selectedGraphData.chartObj"
					[chartConfigurationObj]="selectedGraphData.chartObjConfig"
				></app-donut>
				<div *ngIf="!selectedGraphData || !selectedGraphData.seriesHasData" class="device-metric-no-data">
					No Data Available
				</div>
			</div>
		</div>
		<div class="card card1 mLeft devices-carousel creative-performance-stats display-creative-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="devices-data-container height-100p" *ngIf="hasData">
				<div class="c-portlet__header">
					<div class="o-stack__cell">
						<h5>Device Breakdown</h5>
					</div>
				</div>
				<div class="device-breakdown-data">
					<div>
						<div class="devices-header-row">
							<div class="width-33p device-data">Device</div>
							<div class="width-33p device-data">Impressions</div>
						</div>
						<div class="devices-body">
							<div *ngFor="let device of deviceData; let index = index">
								<div
									class="width-33p device-data font-600p"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									{{ device.device }}
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.impressions">{{ device.impressions | formatNumber }}</div>
									<div *ngIf="!device.impressions">--</div>
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="isCtv || isAudio">
						<div class="devices-header-row">
							<div class="width-33p device-data">Device</div>
							<div *ngIf="isCtv" class="width-33p device-data">Household Site Visits</div>
							<div *ngIf="isAudio" class="width-33p device-data">Website Attributions</div>
						</div>
						<div class="devices-body">
							<div *ngFor="let device of deviceData; let index = index">
								<div
									class="width-33p device-data font-600p"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									{{ device.device }}
								</div>
								<div *ngIf="isCtv"
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.household_visits">{{ device.household_visits | formatNumber }}</div>
									<div *ngIf="!device.household_visits">--</div>
								</div>
								<div *ngIf="isAudio"
								class="width-33p device-data"
								[ngClass]="{
									'primary-color': index === 0,
									'secondary-color': index === 1,
									'tertiary-color': index === 2
								}"
							>
								<div *ngIf="device.website_attributions">{{ device.website_attributions | formatNumber }}</div>
								<div *ngIf="!device.website_attributions">--</div>
							</div>
							</div>
						</div>
					</div>
					<div *ngIf="checkFor('clicks')">
						<div class="devices-header-row">
							<div class="width-33p device-data">Device</div>
							<div class="width-33p device-data">Clicks</div>
							<div class="width-33p device-data">CTR</div>
						</div>
						<div class="devices-body">
							<div *ngFor="let device of deviceData; let index = index">
								<div
									class="width-33p device-data font-600p"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									{{ device.device }}
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.clicks">{{ device.clicks | formatNumber }}</div>
									<div *ngIf="!device.clicks">--</div>
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.clickThroughRate">{{ device.clickThroughRate }}%</div>
									<div *ngIf="!device.clickThroughRate">--</div>
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="checkFor('viewThroughRate')">
						<div class="devices-header-row">
							<div class="width-33p device-data">Device</div>
							<div class="width-33p device-data">View Throughs</div>
							<div class="width-33p device-data">VTR</div>
						</div>
						<div class="devices-body">
							<div *ngFor="let device of deviceData; let index = index">
								<div
									class="width-33p device-data font-600p"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									{{ device.device }}
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.viewThroughs">{{ device.viewThroughs | formatNumber }}</div>
									<div *ngIf="device.viewThroughs === 0">0</div>
									<div *ngIf="device.viewThroughs !== 0 && !device.viewThroughs">--</div>
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.viewThroughRate">{{ device.viewThroughRate }}%</div>
									<div *ngIf="device.viewThroughRate === 0">0%</div>
									<div *ngIf="device.viewThroughRate !== 0 && !device.viewThroughRate">--</div>
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="youtubeViewsPermission && isPreroll">
						<div class="devices-header-row">
							<div class="width-33p device-data">Device</div>
							<div class="width-33p device-data">YouTube Views</div>
							<div class="width-33p device-data">YouTube View Rate</div>
						</div>
						<div class="devices-body">
							<div *ngFor="let device of deviceData; let index = index">
								<div
									class="width-33p device-data font-600p"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									{{ device.device }}
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.youtube_verified_imprs">{{ device.youtube_verified_imprs | formatNumber }}</div>
									<div *ngIf="device.youtube_verified_imprs === 0">0</div>
									<div *ngIf="device.youtube_verified_imprs !== 0 && !device.youtube_verified_imprs">--</div>
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.youtubeVerifiedImprsRate">{{ device.youtubeVerifiedImprsRate }}%</div>
									<div *ngIf="device.youtubeVerifiedImprsRate === 0">0%</div>
									<div *ngIf="device.youtubeVerifiedImprsRate !== 0 && !device.youtubeVerifiedImprsRate">--</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
